// GENERATED by tools/build/gen-icon-data.mjs (npm run gen:icon-data) from the PHP catalogs.
// StaticHelp — contextual help-tooltip icons (icon-only).
import type { IconMap } from '../types';

export const STATIC_HELP_ICONS: IconMap = {
	"ability_choice": {
		"file": "ability_choice",
		"tooltip": "A spell, ability, menta, or curse consists of multiple possible effects. These effects are chosen from a selection. That selection then determines the specific effect or spell that is cast or used."
	},
	"base_object_help": {
		"file": "info",
		"tooltip": "A base object has an item type, which may restrict certain abilities or passive ability enchantments. The object must be equipped by the caster to gain any spell, charged ability, or passive ability enchanted or runeforged onto it."
	},
	"charged_spells_help": {
		"file": "info",
		"tooltip": "Charged spells require item charges to function. Each spell level cast using charges consumes one item charge per level (0-level spells require 1 charge). Item charges always refresh at dawn. Abilities with charges tied to them can also be used as charged abilities."
	},
	"cost_multiplier_help": {
		"file": "info",
		"tooltip": "Certain enchantments can multiply the total cost, such as those involving gemstone size or gemstone cuts."
	},
	"enchantment_template_help": {
		"file": "info",
		"tooltip": "Enchantments can be applied to an item, making it magical or enhancing its properties. These enchantments can be organized into enchantment templates."
	},
	"encounter_add_inventory_name_help": {
		"file": "info",
		"tooltip": "Optional display name for this inventory entry; leave blank to use the chosen item template name."
	},
	"encounter_add_inventory_qty_help": {
		"file": "info",
		"tooltip": "How many stacked units to add. Locked stacks require quantity 1; containers cannot be stacked."
	},
	"encounter_add_item_template_help": {
		"file": "info",
		"tooltip": "Pick the object (item template) to add to this encounter or location inventory."
	},
	"encounter_add_override_cost_gp_help": {
		"file": "info",
		"tooltip": "Optionally replaces the computed gold-piece value for this stack; leave blank to keep template pricing."
	},
	"encounter_description_help": {
		"file": "info",
		"tooltip": "This is the general description of the room the PCs will see when they enter the room and is visible."
	},
	"encounter_gm_notes_help": {
		"file": "info",
		"tooltip": "This is a secret area for you as the GM, visible only from the campaign view when the encounter is loaded."
	},
	"get_available_feats": {
		"file": "info",
		"tooltip": "The feats selection can vary on many factors: race, background, and total character level. Make sure as much of your character is completed out before selecting feats."
	},
	"imbued_spells_help": {
		"file": "info",
		"tooltip": "Imbued Spells are at-will spells or innate spells usable per long rest that can be enchanted onto an item. These spells must not require special ability charges to cast and should not have class or subclass restrictions."
	},
	"item_charges_help": {
		"file": "info",
		"tooltip": "Item charges must always be at least equal to the highest level spell charge, with each spell level representing one charge and a minimum of one charge per spell. For every 10 charges, you receive a 10% discount on the total charge cost. At 20 charges, this discount increases to 20%."
	},
	"item_rechargeable_help": {
		"file": "info",
		"tooltip": "Yes: Items fully recharge to their maximum charges after a long rest. No: Items do not recharge, and the magic is lost after the item is used. If switched to No, the charged spell/ability modifier is reduced to 1 (from 3)."
	},
	"overcharge_type_help": {
		"file": "info",
		"tooltip": "Items with 10 charges automatically gain Minor Overcharge. Items with more than 20 charges automatically gain Major Overcharge."
	},
	"reschedule_session": {
		"file": "schedule",
		"tooltip": "Reschedule Session"
	},
	"runeforging_help": {
		"file": "info",
		"tooltip": "Passive abilities require no charges to use, and are always in effect for the wearer. The Runeforging skill is used to apply these passive abilities."
	}
};
